import React, {Fragment, useState} from 'react'
import {Helmet} from 'react-helmet'
import {Link} from 'react-router-dom'

import ThemeMenuThree from '../../../components/header/ThemeMenuThree'
import PageTitle from '../../../components/page-title/PageTitle'
import FeatureThree from '../../../components/feature/FeatureThree'
import BlockStyleOneA from '../../../components/block/BlockStyleOneA'
import CounterTwoA from '../../../components/counter/CounterTwoA'
import TeamTwo from '../../../components/team/TeamTwo'
import PricingTab from '../../../components/price/PricingTab'
import NewsletterOne from '../../../components/call-to-action/NewsletterOne'
import FooterThree from '../../../components/footer/FooterThree'
import ModalVideos from '../../../components/modal-video/ModalVideos'
import BlogAuthor from "../../../components/blog/BlogAuthor.jsx";
import SocialMedia from "../../../components/blog/SocialMedia.jsx";
import BlogAuthorTwo from "../../../components/blog/BlogAuthorTwo.jsx";
import BlogComment from "../../../components/blog/BlogComment.jsx";
import CommentForm from "../../../components/form/CommentForm.jsx";
import SearchForm from "../../../components/form/SearchForm.jsx";
import CategoryWidgetTwo from "../../../components/widget/CategoryWidgetTwo.jsx";
import WidgetPost from "../../../components/widget/WidgetPost.jsx";
import CategoryTag from "../../../components/widget/CategoryTag.jsx";
import NewsletterTwo from "../../../components/call-to-action/NewsletterTwo.jsx";
import {useTranslation} from 'react-i18next';

const About = () => {
    const {t} = useTranslation();
    const [open, setOpen] = useState(false);
    const OpenModal = () => {
        setOpen(!open)
    }

    return (
        <Fragment>
            <ModalVideos isOpen={open} onClick={OpenModal}/>
            <div className="main-page-wrapper">
                {/* Helmet start */}
                <Helmet>
                    <title>About us</title>
                </Helmet>
                {/* Helmet end */}

                {/* ThemeMenuThree */}
                <ThemeMenuThree/>
                {/* ThemeMenuThree */}

                {/* PageTitle */}
                {/*<PageTitle title="Blog Details Two" />*/}
                {/* PageTitle */}

                {/*blog-single-area start*/}
                <section className="blog-single-area pt-150 pb-80 pt-lg-60">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-8 mb-60">
                                <div className="blog-style-five mb-25">
                                    <div className="blog-content">
                                        <h3><Link className="blog-title">{t('block7')}</Link></h3>
                                    </div>
                                    <p className="text-white mb-25">{t('block8')}</p>

                                    <h3 className="sect-title-two mb-40 mt-50">1. Danger</h3>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Child Exploitation</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block33')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Dark Market</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block34')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Dark Service</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block35')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Enforcement action</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block36')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Fraudulent Exchange</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block37')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Gambling</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block38')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Illegal Service</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block39')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Mixer</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block40')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Ransom</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block41')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Sanctions</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block42')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Scam</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block43')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Stolen Coins</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block44')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Terrorism Financing</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block45')}</p>
                                    <br/>

                                    <h3 className="sect-title-two mb-40 mt-50">2. Suspicious sources</h3>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>ATM</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block46')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Exchange | High Risk</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block47')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Liquidity Pools</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block48')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>P2P Exchange | High Risk</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block49')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Unnamed Service</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block50')}</p>
                                    <br/>

                                    <h3 className="sect-title-two mb-40 mt-50">3. Trusted sources</h3>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Exchange</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block51')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>ICO</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block52')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Marketplace</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block53')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Merchant Services</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block54')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Miner</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block55')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Other</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block56')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>P2P Exchange</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block57')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Payment Management</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block58')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Seized Assets</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block59')}</p>
                                    <br/>

                                    <div className="blog-single-content">
                                        <ul className="text-list list-none">
                                            <li>Wallet</li>
                                        </ul>
                                    </div>
                                    <p className="text-white">{t('block60')}</p>
                                    <br/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*blog-single-area end*/}


                {/* FooterThree start */}
                <FooterThree/>
                {/* FooterThree end */}

            </div>

        </Fragment>
    )
}

export default About